export const  transitionNameMap = [
    {
      name: 'noTransition',
      value: '',
    },
    {
      name: 'split',
      value: 'Split',
      controlDirections: [1, 0],
    },
    {
      name: 'blinds',
      value: 'Blinds',
      controlDirections: [0, 0],
    },
    {
      name: 'box',
      value: 'Box',
      controlDirections: [1, 0],
    },
    {
      name: 'wipe',
      value: 'Wipe',
      controlDirections: [2, 6],
    },
    {
      name: 'dissolve',
      value: 'Dissolve',
    },
    {
      name: 'glitter',
      value: 'Glitter',
      controlDirections: [6, 2],
    },
    {
      name: 'push',
      value: 'Push',
      controlDirections: [3, 1],
    },
    {
      name: 'cover',
      value: 'Cover',
      controlDirections: [6, 2],
    },
    {
      name: 'uncover',
      value: 'Uncover',
      controlDirections: [6, 2],
    },
    {
      name: 'fade',
      value: 'Fade',
    },
    {
      name: 'replace',
      value: 'Replace',
    },
    {
      name: 'fly',
      value: 'Fly',
      controlDirections: [3, 1],
    },
  ]
  const eightDirections = [
      {
        value: '0',
        name: 'R',
      },
      {
        value: '1',
        name: 'RU',
      },
      {
        value: '2',
        name: 'U',
      },
      {
        value: '3',
        name: 'LU',
      },
      {
        value: '4',
        name: 'L',
      },
      {
        value: '5',
        name: 'LD',
      },
      {
        value: '6',
        name: 'D',
      },
      {
        value: '7',
        name: 'RD',
      },
  ]
  const fourDirections = [
      {
          value: '0',
          name: 'R',
      },
      {
          value: '1',
          name: 'U',
      },
      {
          value: '2',
          name: 'L',
      },
      {
          value: '3',
          name: 'D',
      }
  ]
  export const transitionDirectionMap = {
    Split: [
        {
          value: '0', 
          name: 'HI',
        },
        {
          value: '1', 
          name: 'HO',
        },
        {
          value: '2', 
          name: 'VI',
        },
        {
          value: '3', 
          name: 'VO',
        }
    ],
    Blinds: [
        {
            value: '0', 
            name: 'H',
        },
        {
            value: '1', 
            name: 'V',
        },
      ],
    Box: [
        {
            value: '0', 
            name: 'I',
        },
        {
            value: '1', 
            name: 'O',
        },
      ],
    Wipe: eightDirections,
    Glitter:  eightDirections,
    Push: fourDirections,
    Cover: eightDirections,
    Uncover: eightDirections,
    Fly:  fourDirections,
  }